import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { get, filter, includes } from "lodash";

import { fetchGet } from "../../../api/fetch";

import withWidth, { isWidthDown } from "@material-ui/core/withWidth";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import Picture from "../../Common/Picture";
import { UserStatus } from "../../Common/UserStatus";
import HumanView from "./HumanView";
import VehicleView from "./VehicleView";
import GenericView from "./GenericView";
import InfoSection from "../../Common/InfoSection";

import { isAllowed } from "../../../utils/users";
import { isUnknownProfile } from "../../../utils/profile";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import ProfileLocation from "./ProfileLocation";
import { excludeAttr } from "../../../constants/profiles";
import ContainerView from "./ContainerView";
import RailCarView from "./RailCarView";

const styles = (theme) => ({
  dialogRoot: {
    zIndex: "800 !important",
  },
  dialog: {
    width: "400px",
    maxHeight: "calc(100vh - 100px)",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px 24px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    fontSize: "1em",
    margin: "20px",
    color: colors.black54,
  },
  postCreationBtn: {
    margin: "10px 0px",
  },
  titleBarItem: {
    display: "flex",
    alignItems: "center",
    height: "25px",
  },
  borderedPicture: {
    border: "1px solid " + colors.veryLighPink,
    width: "72px",
    height: "72px",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "8px",
    marginRight: "8px",
  },
  secondaryLink: {
    color: colors.black87,
    textTransform: "uppercase",
    cursor: "pointer",
    padding: "8px",
    fontWeight: 500,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  profileContainer: {
    [theme.breakpoints.up("sm")]: {
      height: "100%",
      minWidth: "800px",
      width: "calc(100vw - 80px)",
      maxWidth: "100%",
      padding: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
  },
});

const ProfileViewMatched = (props) => {
  const {
    classes,
    user,
    profile,
    profileType,
    lov,
    language,
    edit,
    photos = [],
    disable = {},
    profileAttributes,
    isMe,
    permissions,
    refresh,
  } = props;

  const [showSecondaryDetails, setShowSecondaryDetails] = React.useState(false);

  const mobileDisplay = isWidthDown("sm", props.width);

  const [sites, setSites] = React.useState();

  const siteId = get(profile, ["site_id"]);
  React.useEffect(() => {
    const fetchSite = async () => {
      if (!isNaN(parseInt(siteId))) {
        try {
          setSites(
            await fetchGet(
              `companies/${get(profile, ["company_id"])}/sites/${get(profile, [
                "site_id",
              ])}`
            )
          );
        } catch (e) {
          console.log(e);
        }
      } else if (!isNaN(parseInt(get(profile, ["company_id"])))) {
        try {
          let company = await fetchGet(
            `companies/${get(profile, ["company_id"])}`
          );
          setSites({ company_name: get(company, ["name"]) });
        } catch (e) {
          console.log(e);
        }
      }
    };
    setSites();
    fetchSite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteId]);

  React.useEffect(() => {
    if (!get(profile, ["company_id"])) {
      setSites();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sites]);

  const itemSizes = {
    xs: 6,
    sm: 3,
    md: 3,
    xl: 3,
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      className={classes.profileContainer}
      style={{
        padding: disable.containerPadding ? "0px" : "",
      }}
      wrap="nowrap"
    >
      {!disable.topBar && (
        <Grid item style={{ paddingBottom: "12px" }}>
          <Grid container>
            <Grid
              item
              xs={2}
              className={classes.titleBarItem + " bold-500"}
              style={{ textTransform: "uppercase" }}
            >
              <UserStatus active={profile.active} />
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={4} />
            <Grid
              item
              xs={4}
              style={{ justifyContent: "flex-end" }}
              className={classes.titleBarItem}
            >
              {edit && !isUnknownProfile(profile.id) && !mobileDisplay && (
                <img
                  src={
                    isMe && !isAllowed(permissions, "me.details.update")
                      ? images.editIconDisabled
                      : images.editIconColored
                  }
                  alt="edit"
                  style={{
                    cursor:
                      isMe && !isAllowed(permissions, "me.details.update")
                        ? ""
                        : "pointer",
                  }}
                  onClick={() =>
                    isMe && !isAllowed(permissions, "me.details.update")
                      ? ""
                      : edit()
                  }
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item style={{ marginBottom: "20px" }}>
        <Grid container wrap="nowrap">
          {profileType === 1 ? (
            <>
              <Grid item>
                <Box
                  className="text-87 bold-500"
                  style={{ /*marginLeft: "8px",*/ marginBottom: "10px" }}
                >
                  {I18n.get("site_indexedPhotos")}
                </Box>
                <Grid container>
                  {photos.filter(
                    (img) => img.active && img.enrollment_status === true
                  ).length > 0 ? (
                    photos
                      .filter(
                        (img) => img.active && img.enrollment_status === true
                      )
                      .map((img) => (
                        <Grid item key={img.url}>
                          <Grid container direction="column">
                            <Grid item className={classes.borderedPicture}>
                              <Picture
                                url={img.url}
                                maxHeight={70}
                                alt="profile_img"
                                style={{ maxHeight: "70px", maxWidth: "70px" }}
                                noZoom={props.blockLevel2}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ))
                  ) : (
                    <Grid
                      item
                      className="text-54 flexCenter"
                      style={{
                        fontStyle: "italic",
                        height: "70px",
                        marginLeft: "8px",
                      }}
                    >
                      {I18n.get("site_noPhoto")}
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                style={{
                  borderLeft: `1px solid ${colors.black87}`,
                  marginLeft: "10px",
                  paddingLeft: "10px",
                }}
              >
                <Box
                  className="text-87 bold-500"
                  style={{ marginLeft: "8px", marginBottom: "10px" }}
                >
                  {I18n.get("site_unindexedPhotos")}
                </Box>
                <Grid container>
                  {photos.filter(
                    (img) => img.active && img.enrollment_status === false
                  ).length > 0 ? (
                    photos
                      .filter(
                        (img) => img.active && img.enrollment_status === false
                      )
                      .map((img) => (
                        <Grid item key={img.url}>
                          <Grid container direction="column">
                            <Grid item className={classes.borderedPicture}>
                              <Picture
                                url={img.url}
                                maxHeight={70}
                                alt="profile_img"
                                style={{ maxHeight: "70px", maxWidth: "70px" }}
                                noZoom={props.blockLevel2}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ))
                  ) : (
                    <Grid
                      item
                      className="text-54 flexCenter"
                      style={{
                        fontStyle: "italic",
                        height: "70px",
                        marginLeft: "8px",
                      }}
                    >
                      {I18n.get("site_noPhoto")}
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid item>
              <Box
                className="text-87 bold-500"
                style={{ /*marginLeft: "8px",*/ marginBottom: "10px" }}
              >
                {I18n.get("site_profilePhotos")}
              </Box>
              <Grid container>
                {photos.filter((img) => img.active).length > 0 ? (
                  photos
                    .filter((img) => img.active)
                    .map((img) => (
                      <Grid item key={img.url}>
                        <Grid container direction="column">
                          <Grid item className={classes.borderedPicture}>
                            <Picture
                              url={img.url}
                              maxHeight={70}
                              alt="profile_img"
                              style={{ maxHeight: "70px", maxWidth: "70px" }}
                              noZoom={props.blockLevel2}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    ))
                ) : (
                  <Grid
                    item
                    className="text-54 flexCenter"
                    style={{
                      fontStyle: "italic",
                      height: "70px",
                      marginLeft: "8px",
                    }}
                  >
                    {I18n.get("site_noPhoto")}
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item style={{ marginBottom: "20px" }}>
        {profileType === 1 ? (
          <HumanView
            section="main"
            data={profile}
            lov={lov}
            language={language}
            profileAttributes={filter(
              profileAttributes,
              (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
            )}
          />
        ) : profileType === 2 || profileType === 3 ? (
          <VehicleView
            profileType={profileType}
            section="main"
            data={profile}
            lov={lov}
            language={language}
            profileAttributes={filter(
              profileAttributes,
              (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
            )}
          />
        ) : profileType === 8 ? (
          <RailCarView
            profileType={profileType}
            section="main"
            data={profile}
            lov={lov}
            language={language}
            profileAttributes={profileAttributes}
          />
        ) : (
          <ContainerView
            profileType={profileType}
            section="main"
            data={profile}
            lov={lov}
            language={language}
            profileAttributes={profileAttributes}
          />

        )}
        <Grid
          container
          style={{
            marginTop: "20px",
            maxWidth: "770px",
            backgroundColor: colors.lightGrey,
          }}
        >
          <Grid
            item
            className="flexCenter"
            style={{
              justifyContent: "center",
              width: "50px",
            }}
          >
            <img src={images.companyIcon} alt="company" />
          </Grid>
          <Grid
            item
            style={{
              maxWidth: "220px",
              width: "220px",
              paddingTop: "10px",
            }}
          >
            <Grid container direction="column">
              <InfoSection
                title="assignedCompany"
                values={[get(sites, ["company_name"])]}
              />
            </Grid>
          </Grid>
          <Grid
            item
            style={{
              maxWidth: "220px",
              width: "220px",
              paddingTop: "10px",
            }}
          >
            <Grid container direction="column">
              <InfoSection
                title="assignedSite"
                values={[get(sites, ["name"])]}
              />
            </Grid>
          </Grid>
          <Grid
            item
            style={{
              maxWidth: "220px",
              width: "220px",
              paddingTop: "10px",
            }}
          >
            <Grid container direction="column">
              <InfoSection
                title="assignedZone"
                values={[
                  get(
                    filter(
                      get(sites, ["zones"]),
                      (z) => z.id === get(profile, ["zone_id"])
                    ),
                    [0, "name"]
                  ),
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
        <ProfileLocation
          itemSizes={itemSizes}
          profileType={profileType}
          profile={profile}
          user={user}
          refresh={refresh}
          editDisabled={!props.editLocation}
        />
      </Grid>
      <Grid item style={{ marginBottom: "20px" }}>
        <Box
          onClick={() => setShowSecondaryDetails(!showSecondaryDetails)}
          className={classes.secondaryLink}
        >
          <img
            src={showSecondaryDetails ? images.bottomArrow : images.rightArrow}
            alt="arrow"
            style={{ marginRight: "5px" }}
          />
          {I18n.get("site_secondaryDetails")}
        </Box>
        {showSecondaryDetails &&
          (profileType === 1 ? (
            <HumanView
              section="secondary"
              data={profile}
              lov={lov}
              language={language}
              profileAttributes={filter(
                profileAttributes,
                (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
              )}
            />
          ) : profileType === 2 || profileType === 3 ? (
            <VehicleView
              profileType={profileType}
              section="secondary"
              data={profile}
              lov={lov}
              language={language}
              profileAttributes={filter(
                profileAttributes,
                (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
              )}
            />
          ) : (
            <GenericView
              profileType={profileType}
              section="secondary"
              data={profile}
              lov={lov}
              language={language}
              profileAttributes={profileAttributes}
            />
          ))}
      </Grid>
    </Grid>
  );
};

ProfileViewMatched.propTypes = {
  profileType: PropTypes.number,
  profile: PropTypes.object,
  lov: PropTypes.object,
  edit: PropTypes.func,
  photos: PropTypes.array,
  disable: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
    user: get(state, ["user"]),
  };
};

export default connect(mapStateToProps)(
  withWidth()(withStyles(styles)(ProfileViewMatched))
);
